// Save requirement answers ************************************************************************
// pathname: /v1/job-interview/save-requirement-answer-list
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

/** Props */
interface UseSwrSaveRequirementAnswersProps {
  locale: Locale,
  successCallback?: () => void,
  errorCallback?: (error: ApiSchema<'ErrorResponse'>) => void,
}

/**
 * @description SWR mutation: save requirement question answers.
 * - `locale` - the current locale
 * - `successCallback` - callback to call on success
 * - `errorCallback` - callback to call on error
 */
export const useSwrSaveRequirementAnswers = (props: UseSwrSaveRequirementAnswersProps) => {
  const {
    locale,
    successCallback,
    errorCallback,
  } = props;

  return useSwrMutationApi<void, ApiSchema<'RequirementAnswerListWrite'>>({
    url: '/v1/job-interview/save-requirement-answer-list',
    locale,
    fetcherConfig: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
      onError: (error) => {
        if (errorCallback) errorCallback(error);
      },
    },
    toastsOptions: {
      showSuccessToast: false,
      showErrorToast: true,
    },
  });
};
